import ArrowLeft from "@/components/Svg/ArrowLeft";
import { DataBannerTypes } from "@/types/BannerType";
import Image from "next/image";
import Link from "next/link";
import React from "react";

function TwoBanner({ dataTemplate }: DataBannerTypes) {
  const twoBannerLink = `pt-[50%] md:pt-[55%] rounded-[0.75rem]  sm:rounded-[1.5rem]  lg:rounded-3xl relative  overflow-hidden`;
  const twoBannerImageClass = `w-full h-full object-cover rounded-[0.75rem] sm:rounded-[1.5rem] lg:rounded-3xl absolute inset-0 hover:filter z-20 hover:blur-[2px] transition-all duration-300`;
  const twoBannerParentSpan = `absolute bottom-0 flex  items-end justify-center z-30  w-full rounded-b-2xl lg:rounded-b-3xl  h-max text-white md:text-lg sm:text-lg text-xs lg:text-3xl`;
  const twoBannerSpan = `lg:p-10 p-6  text-right  flex  items-center gap-2 lg:gap-6    w-full bg-gradient-to-t z-30 from-[#1A1818] to-transparent `;
  const twoBannerArrow = `stroke-[#FFC20A]`;

  return (
    <div className="grid md:grid-cols-2 grid-cols-1 gap-3 lg:gap-10 my-5 lg:my-5 lg:px-16 px-6">
      {dataTemplate?.map((twoTemplateData, index) => (
        <Link
          key={index + 1}
          href={twoTemplateData?.link ?? "/"}
          style={{ order: Number(twoTemplateData?.positionInTemplate) }}
          className={twoBannerLink}
        >
          <Image
            priority
            fetchPriority="high"
            sizes="100vw"
            unoptimized
            src={twoTemplateData?.patchImage ?? "/images/default.png"}
            quality={100}
            width={5000}
            height={3000}
            className={twoBannerImageClass}
            alt={`banner-${index + 1}`}
          />
          <span className={twoBannerParentSpan}>
            <span className={twoBannerSpan}>
              {twoTemplateData?.title}
              <ArrowLeft className={twoBannerArrow} />
            </span>
          </span>
        </Link>
      ))}
    </div>
  );
}

export default TwoBanner;
